import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContentPoolStatusComponent } from '../content-pool-status/content-pool-status';
import { ContentMapperService } from '../../../app/core/services/content-mapper-service';
import { segment_endpoint } from '../../../app/data/api-endpoint/segment-endpoint';
import { CommonService } from '../../../app/core/services/common.service';
export interface ModalConfig {
  isOpen: boolean;
  type: 'delete' | 'deactivate' | 'activate' | 'user-delete' | 'user-deactivate' | 'user-activate' | 'segment-review';
  contentName?: string;
  segmentData?: any;
}

@Component({
  selector: 'app-shared-modal',
  imports: [CommonModule, FormsModule,ContentPoolStatusComponent],
  templateUrl: './shared-modal.html',
  styleUrl: './shared-modal.scss'
})
export class SharedModal {

  @Input() modalConfig: ModalConfig = {
    isOpen: false,
    type: 'delete'
  };

  @Output() confirm = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  selectedStatus: 'activate' | 'reject' = 'activate';

  warningIcon = 'assets/img/warning.png';
  deleteIcon = 'assets/img/warning.png';
  activateIcon = 'assets/img/success.svg';
  reviewIcon = 'assets/img/security.svg';

  constructor(private contentMapper: ContentMapperService, private commonService: CommonService){

  }

  onConfirm(): void {
    if (this.modalConfig.type === 'segment-review') {
      this.confirm.emit({
        status: this.selectedStatus,
        segmentData: this.modalConfig.segmentData
      });
    } else {
      this.confirm.emit();
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }

  getModalTitle(): string {
    switch (this.modalConfig.type) {
      case 'delete':
        return 'Delete Content Pool';
      case 'deactivate':
        return 'Deactivate Content Pool';
      case 'activate':
        return 'Activate Content Pool';
      case 'user-delete':
        return 'Delete User';
      case 'user-deactivate':
        return 'Deactivate User';
      case 'user-activate':
        return 'Activate User';
      case 'segment-review':
        return 'Review Segment';
      default:
        return 'Confirm Action';
    }
  }

  getModalMessage(): string {
    switch (this.modalConfig.type) {
      case 'delete':
        return `Are you sure you want to delete this content pool ?`;
      case 'deactivate':
        return `Are you sure you want to deactivate this content pool?`;
      case 'activate':
        return `Are you sure you want to activate this content pool?`;
      case 'user-delete':
        return `Are you sure you want to delete this user?`;
      case 'user-deactivate':
        return `Are you sure you want to deactivate this user?`;
      case 'user-activate':
        return `Are you sure you want to activate this user?`;
      case 'segment-review':
        return `Please select the action for segment "${this.modalConfig.segmentData?.name || 'Unknown'}" on The Trade Desk:`;
      default:
        return 'Are you sure you want to perform this action?';
    }
  }

  getConfirmButtonText(): string {
    switch (this.modalConfig.type) {
      case 'delete':
        return 'Delete';
      case 'deactivate':
        return 'Deactivate';
      case 'activate':
        return 'Activate';
      case 'user-delete':
        return 'Delete';
      case 'user-deactivate':
        return 'Deactivate';
      case 'user-activate':
        return 'Activate';
      case 'segment-review':
        return this.selectedStatus === 'reject' ? 'Reject Segment' : 'Approve Segment';
      default:
        return 'Confirm';
    }
  }

  getConfirmButtonClass(): string {
    if (this.modalConfig.type === 'segment-review' && this.selectedStatus === 'reject') {
      return 'segment-review reject-action';
    }
    return this.modalConfig.type;
  }

  getIconSrc(): string {
    switch (this.modalConfig.type) {
      case 'delete':
      case 'user-delete':
        return this.deleteIcon;
      case 'deactivate':
      case 'user-deactivate':
      return this.warningIcon;
      case 'activate':
      case 'user-activate':
        return this.activateIcon;
      case 'segment-review':
        return this.reviewIcon;
      default:
        return this.warningIcon;
    }
  }

  // getCurrentSegment(segment_id: any): void {
  //   this.loader = true;
  //   this.contentPoolStatus = []
  //   this.contentMapper.get(segment_endpoint.segment + `/${segment_id}`).subscribe({
  //     next: (response: any) => {
  //       const { segment } = response.results
  //       const { activeContentIds, addedContentIds, removedContentIds } = segment;
  //       activeContentIds.forEach((item: any) => {
  //         this.contentPoolStatus.push({ name: item.name, id: item.id, status: 'active' })
  //       })
  //       addedContentIds.forEach((item: any) => {
  //         this.contentPoolStatus.push({ name: item.name, id: item.id, status: 'pending' })
  //       })
  //       removedContentIds.forEach((item: any) => {
  //         this.contentPoolStatus.push({ name: item.name, id: item.id, status: 'deleted' })
  //       })

  //       this.commonService.updateShareContentPoolStatus(this.contentPoolStatus)
  //       this.loader = false;
  //     },
  //     error: (error: any) => {
  //       this.loader = false;
  //       console.error('Error occurred while fetching current segment', error.message);
  //     }
  //   });
  // }
}
